import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

interface PendingUser {
  id: number;
  username: string;
  email: string;
  displayName: string;
  createdAt: string;
}

@Component({
    selector: 'app-admin-panel',
    imports: [CommonModule],
    templateUrl: './admin-panel.component.html',
    styleUrls: ['./admin-panel.component.scss']
})
export class AdminPanelComponent implements OnInit {
  pendingUsers: PendingUser[] = [];
  loading = false;
  error: string | null = null;

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.loadPendingUsers();
  }

  async loadPendingUsers() {
    this.loading = true;
    this.error = null;

    try {
      this.pendingUsers = await this.http.get<PendingUser[]>(
        `${environment.apiBaseUrl}/auth/admin/pending-users`
      ).toPromise() as PendingUser[];
    } catch (err: any) {
      this.error = 'Erreur lors du chargement des utilisateurs en attente';
      console.error(err);
    } finally {
      this.loading = false;
    }
  }

  async approveUser(userId: number) {
    if (!confirm('Approuver cet utilisateur ?')) {
      return;
    }

    try {
      await this.http.post(
        `${environment.apiBaseUrl}/auth/admin/approve-user/${userId}`,
        {}
      ).toPromise();

      // Retirer l'utilisateur de la liste
      this.pendingUsers = this.pendingUsers.filter(u => u.id !== userId);
      alert('Utilisateur approuvé avec succès');
    } catch (err: any) {
      alert('Erreur lors de l\'approbation');
      console.error(err);
    }
  }

  async rejectUser(userId: number) {
    if (!confirm('Rejeter cet utilisateur ?')) {
      return;
    }

    try {
      await this.http.post(
        `${environment.apiBaseUrl}/auth/admin/reject-user/${userId}`,
        {}
      ).toPromise();

      // Retirer l'utilisateur de la liste
      this.pendingUsers = this.pendingUsers.filter(u => u.id !== userId);
      alert('Utilisateur rejeté');
    } catch (err: any) {
      alert('Erreur lors du rejet');
      console.error(err);
    }
  }
}
